import { animate, style, transition, trigger } from "@angular/animations";

export const fadeInOut = trigger("fadeInOut", [
  transition(":enter", [
    // void => *
    style({ opacity: 0 }),
    animate("250ms ease-in", style({ opacity: 1 }))
  ]),
  transition(":leave", [
    // * => void
    animate("250ms ease-out", style({ opacity: 0 }))
  ])
]);

export const slideOutLeft = trigger("slideOutLeft", [
  transition("in => out", [
    animate(
      "200ms ease-in",
      style({
        transform: "translateX(-100%)",
        opacity: 0
      })
    )
  ])
]);
